import { render, staticRenderFns } from "./StartChatDialog.vue?vue&type=template&id=70d5cebd&scoped=true"
import script from "./StartChatDialog.vue?vue&type=script&lang=js"
export * from "./StartChatDialog.vue?vue&type=script&lang=js"
import style0 from "./StartChatDialog.vue?vue&type=style&index=0&id=70d5cebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5cebd",
  null
  
)

export default component.exports